module.exports = __webpack_public_path__ + "static/media/student24.30a836c6.png";